import { render } from "./Artboard_Quiz.vue?vue&type=template&id=6da2763e&scoped=true"
import script from "./Artboard_Quiz.vue?vue&type=script&lang=js"
export * from "./Artboard_Quiz.vue?vue&type=script&lang=js"

import "./Artboard_Quiz.vue?vue&type=style&index=0&id=6da2763e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6da2763e"

export default script